<template lang="pug">
  .container
    .row
      .col-md-12
        h1 Política de Privacidad de Grupo Piñon
        p En Controlla, desarrolladora de la aplicación Grupo Piñon, nos comprometemos a proteger la privacidad de nuestros usuarios. La aplicación solo maneja datos relacionados con el inventario de la mercancía y no recopila ni utiliza información personal o sensible de los almacenistas.

        h2 Datos Recogidos
        p Solo registramos información sobre el inventario, como la cantidad de productos y datos de recepción. No se comparte ningún dato con terceros.

        h2 Uso de los Datos
        p Los datos de inventario se usan exclusivamente para la gestión interna y se almacenan de manera segura. No se recopilan ni comparten datos personales.

        h2 Contacto
        p Para cualquier duda visita
          a(href="https://controlla.com.mx") controlla.com.mx
        |  o escribe a
        a(href="mailto:asalaices@controlla.com.mx") asalaices@controlla.com.mx

        p Última actualización: 11 Oct 2024
</template>

<script>
export default {
  name: 'Privacidad'
}
</script>

<style scoped>
.container {
  padding: 20px;
}

h1, h2 {
  margin-bottom: 10px;
}

p {
  margin-bottom: 20px;
}
</style>
